/** Bound once from configureStore.js to avoid circular imports from sagas. */
export let history = null;

export const bindHistory = reduxHistory => {
    history = reduxHistory;
};
